export default __webpack_public_path__ + "static/media/Lesuire.9c96a529.svg";